import type { IUECEpisodesRemaining } from 'plugins/tag/plugin_data_service/ts/Application/interfaces/UEC/IUECEpisodesRemaining';

const disabled = (): IUECEpisodesRemaining => ( {
	enabled: false,
	params: {
		episodesRemaining: 0,
		episodesRemainingText: '',
		poEditorKey: ''
	}
} );

/**
 * @param cpEpisodesRemainingEnabled Host `SmartTagAdapter.CPEpisodesRemainingEnabled`
 * @param recommendations `response.result.apiResponse.recommendations` from up-next
 */
export function formatEpisodesRemaining(
	cpEpisodesRemainingEnabled: boolean,
	recommendations: unknown
): IUECEpisodesRemaining {
	if ( !cpEpisodesRemainingEnabled ) {
		return disabled();
	}

	const list = Array.isArray( recommendations ) ? recommendations : [];
	if ( list.length === 0 ) {
		return disabled();
	}

	const fullEpisodeCount = list.filter( ( item ) => {
		if ( !item || typeof item !== 'object' ) {
			return false;
		}
		const details = ( item as { contentCANDetails?: { fullEpisode?: boolean } } ).contentCANDetails;
		if ( details && typeof details.fullEpisode === 'boolean' ) {
			return details.fullEpisode;
		}
		return true;
	} ).length;

	const episodesRemaining = fullEpisodeCount > 0 ? fullEpisodeCount : list.length;

	return {
		enabled: true,
		params: {
			episodesRemaining,
			episodesRemainingText: '{n}',
			poEditorKey: ''
		}
	};
}